
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefit-support",
      function () {
        return require("private-next-pages/benefit-support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefit-support"])
      });
    }
  